import { Component, OnInit } from '@angular/core';

//services
import { HttpTestService } from '../../services/http.service';
import { sessionServices } from '../../services/session.services';
import { Router, ActivatedRoute } from '@angular/router';

import { greviencemodel } from '../../models/grevience/grevience.model';
import {IMyDpOptions} from 'mydatepicker';


@Component({
  selector: 'app-request-manage',
  templateUrl: './paymentResponse.component.html'
})
export class paymentResponseComponent implements OnInit {

  //variable deceleration
  public errorMsg : string = "";
  public successMsg : string = "";
  public sessionData : any;
  public allRequestData : any = [];
  public allCategoryData : any = [];
  public allSubData : any = [];
  public greviencemodel: greviencemodel = new greviencemodel;
  public popupopen : boolean = false;
  public viewpopupopen : boolean = false;
  public viewStatus : string = "";
  public viewDate : any = "";
  public viewDocket : any = "";
  public viewCat : any = "";
  public viewSubCat : any = "";
  public viewDetails : string = "";
  public checkSumData : any = "";
  public paymentStat : any = "";
  public getTokkendata : any = "";
   
   public myDatePickerOptions: IMyDpOptions = {
        // other options...
        dateFormat: 'dd/mm/yyyy',
		disableUntil : { year: new Date().getFullYear(), month: new Date().getMonth()+1, day: new Date().getDate()-1 }
    };

  constructor(public http: HttpTestService, public session: sessionServices, public router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
	  this.getSession();
	 // this.fetchauthKeyFromUrl();
	 this.fetchauthKeyFromParameter();
	 // alert("ngONInit");
  }
  
  
  //get session details
	getSession = function(){
		this.sessionData = this.session.getSessionDetails();
	}

	fetchauthKeyFromParameter = function(){
		this.getTokkendata = this.route.snapshot.paramMap.get('msg');
		//alert("Tkn data: "+this.getTokkendata);

		if(this.getTokkendata != ""){
			this.checkChecksum()
		}
		
	}
	
	fetchauthKeyFromUrl = function(){
		//alert("Fetch Auth");
		var tokken:any = window.location.href;
		tokken = tokken.split("?");
		//alert("Tkn: "+tokken);
		var requestedUrl = window.location.pathname;
		this.getRequestedUrl = requestedUrl;
		if(tokken.length>1){
		tokken = tokken[1].split("="); 
		}
		if(tokken.length>1){
		this.getTokkendata = tokken[1];
		//alert("Tkn data: "+this.getTokkendata);
	   }
		if(this.getTokkendata != ""){
			this.checkChecksum()
		}
		
	}
	
	
	checkChecksum = function(){
		var self = this;
		var requestedString = self.getTokkendata;
		requestedString = requestedString.split("%7C");
		var prevChcksum = requestedString[requestedString.length-1];
		requestedString.pop();
		requestedString = requestedString.join("%7C");
		requestedString = requestedString.split("%2F");
		requestedString = requestedString.join("fwdSlash");
		self.http.getChecksum(requestedString)
		  .subscribe(
			(data) => {
			  self.checkSumData = data;
			  },
			(error) => {
				self.errorMsg = error;
				self.checkSumData = "";
			},
			() => {
				if(prevChcksum == self.checkSumData.value){
					self.processPayment();
				}else{
					self.getTokkendata = "";
				}
				
				
			}
	);
		
	}
	
processPayment = function(){
	var self = this;
	var getPaymentData = self.getTokkendata.split("%7C");

	if(getPaymentData[13].indexOf("%2B")> -1){
	var formattedDate = getPaymentData[13].split("%2B")[0].split("-")[2]+"-"+getPaymentData[13].split("%2B")[0].split("-")[1]+"-"+getPaymentData[13].split("%2B")[0].split("-")[0];
	var formatTime = getPaymentData[13].split("%2B")[1];
	}else{
	var formattedDate = getPaymentData[13].split("%20")[0].split("-")[2]+"-"+getPaymentData[13].split("%20")[0].split("-")[1]+"-"+getPaymentData[13].split("%20")[0].split("-")[0];
	var formatTime = getPaymentData[13].split("%20")[1];
	}
	var postParamGaya = {
    amount:getPaymentData[4],
	customerId:getPaymentData[1],
    consumerId:getPaymentData[20],
    date:formattedDate,
    lastupdatedDate:formattedDate,
    mobNo:getPaymentData[21],
    orderNo:getPaymentData[22],
    time:formatTime,
    transactionId:getPaymentData[2],
	lvDocType:getPaymentData[7],
	authCode:getPaymentData[14]

}
	self.http.postPaymentGaya(postParamGaya)
		  .subscribe(
			(data) => {
			  self.paymentStat = data;
			  },
			(error) => {
				self.errorMsg = error;
				self.paymentStat = "";
			},
			() => {}
	);
	
}

}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/success/paymentResponse.component.ts